module.exports = __webpack_public_path__ + "static/media/clipboard-tick.714e3bbf.svg";